module.exports = __webpack_public_path__ + "static/mapofcampus.75d932df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mapofcampus.jpg
// module id = 1720
// module chunks = 99330344035853